import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";
import classNames from "classnames";

function ScrollPane(props: Props) {
  const ref = React.useRef<HTMLDivElement>(null);
  const hasScrolledBottom = () =>
    ref.current &&
    (ref.current.scrollHeight === ref.current.clientHeight ||
      ref.current.offsetHeight + ref.current.scrollTop >=
        ref.current.scrollHeight);
  const hasScrolledRight = () =>
    ref.current &&
    (ref.current.scrollWidth === ref.current.clientWidth ||
      ref.current.offsetWidth + ref.current.scrollWidth >=
        ref.current.scrollWidth);

  return (
    <div
      ref={ref}
      className={classNames(styles.scrollPane, props.style)}
      style={{
        overflowX: props.isHorizontal ? "auto" : "initial",
      }}
      onScroll={() => {
        !!props.scrollEnd &&
          (props.isHorizontal ? hasScrolledRight() : hasScrolledBottom()) &&
          props.scrollEnd();
      }}
    >
      {props.children}
    </div>
  );
}

export { ScrollPane };
